import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-sync';

const imageCarousel = {
  init: function() {
    const imageCarousels = document.getElementsByClassName('flickity-image-carousel');

    Array.from(imageCarousels).forEach(carousel => {
      this._initCarousel(carousel);
      window.dispatchEvent(new Event('resize')); // dirty fix for flickity to work with mobile sizes
    });

    window.setTimeout(() => {
      window.dispatchEvent(new Event('resize')); // dirty fix for flickity to work with mobile sizes
    }, 1000);

  },

  _initCarousel: function(carousel) {
    let mainCarouselElement = carousel.getElementsByClassName('image-carousel'),
      thumbnailCarouselElement = carousel.getElementsByClassName('image-carousel-thumbs');

    mainCarouselElement = mainCarouselElement.length ? mainCarouselElement[0] : false;
    thumbnailCarouselElement = thumbnailCarouselElement.length ? thumbnailCarouselElement[0] : false;

    if (!mainCarouselElement) {
      return false;
    }

    const mainFlickity = new Flickity(mainCarouselElement, {
      lazyLoad: true, // at least the first images should be loaded instantly
      pageDots: false,
      wrapAround: true,
      sync: thumbnailCarouselElement,
      initialIndex: document.getElementById('car-video') ? 1 : 0
    });

    const thumbnailFlickity = thumbnailCarouselElement ? new Flickity(thumbnailCarouselElement, {
      asNavFor: mainCarouselElement,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      imagesLoaded: true,
      setGallerySize: false,
    }) : false;

    this._initFullScreenButtons(carousel, mainFlickity, thumbnailFlickity);
    this._initOutsideClick(carousel, mainFlickity, thumbnailFlickity);
    this._initVideoPlayButton();
  },

  _initFullScreenButtons: function(carousel, mainFlickity, thumbnailFlickity) {
    const fullScreenButtons = carousel.getElementsByClassName('carousel-fullscreen-button');

    Array.from(fullScreenButtons).forEach(button => {
      button.addEventListener('click', function(event) {
        carousel.classList.toggle('fullscreen');

        setTimeout(function() {
          mainFlickity.resize();

          if (thumbnailFlickity) {
            thumbnailFlickity.resize();
          }
        }, 10);
      });
    });
  },

  _initVideoPlayButton: () => {
    const button = document.getElementById('video-play-button');
    const video = document.getElementById('car-video');

    if(video && button) {
      button.addEventListener('click', (event) => {
        setTimeout(function() {
          video.play();
        }, 500);
      });

      video.addEventListener('playing', (event) => {
        button.classList.add('hide');
      });
      video.addEventListener('pause', (event) => {
        button.classList.remove('hide');
      });
    }
  },

  _initOutsideClick: function(carousel, mainFlickity, thumbnailFlickity) {
    const self = this;

    document.documentElement.addEventListener('click', function(event) {
      if (
        carousel.classList.contains('fullscreen') &&
        !(self._isParent(event.target, carousel))
      ) {
        carousel.classList.remove('fullscreen');

        setTimeout(function() {
          mainFlickity.resize();

          if (thumbnailFlickity) {
            thumbnailFlickity.resize();
          }
        }, 500);
      }
    });
  },

  _isParent: function(element, targetParent) {
    let parent = element.parentNode;

    while (parent !== document) {
      if (parent === targetParent) {
        return true;
      }
      else {
        parent = parent.parentNode;
      }
    }

    return false;
  }
};

export default imageCarousel;
